
export default {
  name: 'FSwitch',
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    inputValue: {
      type: [Array, Boolean],
      default: false,
    },
    value: {
      type: [Array, Boolean],
      default: false,
    },
    reverseLabel: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    inset: {
      type: Boolean,
      default: true,
    },
    flat: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    hasError: {
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
    },
  },

  methods: {
    bubbleEvent(val) {
      this.$emit('input', val || false);
    },
  },
};
